"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAboutUsState = void 0;
exports.defaultAboutUsState = {
    headerTitle: 'OKAY.COM',
    headerCaption: 'Redefine Real Estate Market',
    knowMore: 'Know More',
    youtubeId: '_hPgKfbQSAw',
    pageTitle: 'Redefine Real Estate Market',
    html: "\n<div>\n  <p>\n    OKAY.com was founded in 2011 with a mission to fundamentally\n    improve the real estate process.\n  </p>\n  <p>To achieve this:</p>\n  <ul class=\"c-article__points\">\n    <li>\n      <p>\n        <span class=\"u-bold\">We created a community</span> of leading\n        real estate agents who share information and leverage it to\n        benefit both homeseekers (with more property options) and\n        landlords (more exposure for your property). Transparency\n        benefits everyone.\n      </p>\n    </li>\n    <li>\n      <p>\n        Instead of spending money on expensive physical storefronts,\n        <span class=\"u-bold\">we focus on technology</span>, building a\n        proprietary, cutting edge mobile platform so OKAY.com agents\n        can send you properties faster, before other homeseekers in\n        the market see them.\n      </p>\n    </li>\n    <li>\n      <p>\n        We designed an award-winning website and only list real,\n        up-to-date properties so you don\u2019t waste time looking through\n        stale listings. It\u2019s why\n        <a href=\"http://www.okay.com\">www.OKAY.com</a>\n        <span class=\"u-bold\"\n          >is a trusted resource used by thousands</span\n        >of homeseekers and landlords every day.\n      </p>\n    </li>\n  </ul>\n  <p>\n    <span class=\"u-bold\">\n      Having helped thousands of clients to lease, purchase or sell\n      their properties, and we look forward to helping you with your\n      real estate needs.\n    </span>\n  </p>\n</div>  \n  ",
    links: [
        {
            image: '/res/img/about-search.jpg',
            text: 'Find a Home',
            link: '#',
        },
        {
            image: '/res/img/about-listing.jpg',
            text: 'List Your Property',
            link: '#',
        },
        {
            image: '/res/img/about-work.jpg',
            text: 'Career',
            link: 'https://career.okay.com',
        },
    ],
    definition: {
        word: 'OKAY',
        pronounce: 'ōˈkā/O-KAY/屋企',
        meanings: [
            {
                type: 'noun',
                detail: [
                    {
                        text: 'O-KAY” [屋企] meaning ‘home’ in Cantonese',
                        example: '"Welcome to my home."',
                    },
                ],
            },
            {
                type: 'adverb',
                detail: [
                    {
                        text: 'in a pleasing and reassuring manner',
                        example: '"It’s OKAY, we’re here to help."',
                    },
                ],
            },
        ],
    },
    isLoaded: false,
    isPlaying: false,
};
